import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import axios from 'axios';
import { apiCallBegan } from './api';
import _ from 'lodash';
import {
  format,
  parseISO,
  isBefore,
  add,
  startOfDay,
  addDays,
  isSameDay
} from 'date-fns';

import config from '../config/config';

// const apiMealEndpoint = '/api/meal/';
const apiToken = process.env.REACT_APP_API_TOKEN;

// Helpers methods
export const getOrderDate = () => {
  const checkToday = isBefore(
    new Date(),
    add(startOfDay(new Date()), {
      hours: config.lastHourForTeamTodayOrder,
      minutes: config.lastMinuteForTeamTodayOrder
    })
  );
  // format(parseISO(m.date),'dd.MM.yyyy')
  return checkToday ? new Date() : addDays(new Date(), 1);
  //  setTodayCheck(checkToday ? true : false)
};

const changeCouponsList = (coupons, newCoupon) =>{
  const index = coupons.findIndex(c => c.id === newCoupon.id)
      
  if(index > -1){
    coupons[index]['amount'] += newCoupon.amount
    if (coupons[index]['amount'] === 0){
      coupons.splice(index, 1);
    }

  }
  else{
    // coupons = [...coupons, newCoupon]
    coupons.push(newCoupon)
    // console.log('changeCouponsList',coupons);
  }
}

// slice
const slice = createSlice({
  name: 'team',
  initialState: {
    today: null,
    orderDate: null,
    orderForToday: false,
    // orderMeals: [],
    orderCoupons: [],
    todayCoupons: [],
    // userId: null,
    coupons: []
  },
  reducers: {
    userCouponsLoaded: (team, action) => {
      const orderDate = getOrderDate();
      const { meals } = action.payload.params;

      team.orderCoupons = [];
      team.todayCoupons = [];

      if (isSameDay(orderDate, new Date())) {
        // До 10 утра
        team.today = format(new Date(), 'dd.MM.yyyy');
        team.orderDate = format(new Date(), 'dd.MM.yyyy');
        team.orderForToday = true;
        team.orderCoupons = action.payload.data.filter(
          c => c.date === format(new Date(), 'yyyy-MM-dd')
        );
        team.todayCoupons = action.payload.data.filter(
          c => c.date === format(new Date(), 'yyyy-MM-dd')
        );
      } else {
        // После 10 утра
        team.today = format(new Date(), 'dd.MM.yyyy');
        team.orderDate = format(orderDate, 'dd.MM.yyyy');
        team.orderForToday = false;
        team.orderCoupons = action.payload.data.filter(
          c => c.date === format(orderDate, 'yyyy-MM-dd')
        );
        team.todayCoupons = action.payload.data.filter(
          c => c.date === format(new Date(), 'yyyy-MM-dd')
        );
      }
    },

    userHistoryLoaded: (team, action) => {
      team.history = action.payload.data; 
    },

    couponChanged: (team, action) => {
      const {
        amount,
        date,
        meal_id,
        eating_id,
        id,
      } = action.payload.data;


      changeCouponsList(team.orderCoupons,{
        amount,
        date,
        meal_id,
        eating_id,
        id,
      })
 

      if(date ===format(new Date(), 'yyyy-MM-dd')){
        changeCouponsList(team.todayCoupons,{
          amount,
          date,
          meal_id,
          eating_id,
          id,
        })
      }



          },

    deleteCoupon: (team, action) => {
      const {
        mealId,
        date,
        meetingId,
        eventeatingId,
        eatingId
      } = action.payload;
      // console.log('deleteCoupon',mealId, date, meetingId, eventeatingId, eatingId);
      team.coupons = team.coupons.filter(
        c =>
          c.mealId !== mealId ||
          c.date !== date ||
          c.meetingId !== meetingId ||
          c.eventeatingId !== eventeatingId ||
          c.eatingId !== eatingId
      );
      // team.coupons = team.coupons.filter(c => c.mealId !== mealId)
      // console.log('team.coupons', team.coupons);
    }
  }
});

export const {
  userCouponsLoaded,
  couponChanged,
  deleteCoupon,
  userCouponsDeleted,
  userHistoryLoaded
} = slice.actions;
export default slice.reducer;

// Action Creators

export const loadUserCoupons = (userId, checkDate, token) => async (
  dispatch,
  getState
) => {
  const checkDateFormated = checkDate.split('.').join('');
  const meals = getState().entities.meal.list;
  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/user_eating/${userId}/${checkDateFormated}?token=${token}&secret_key=${apiToken}`,
      onSuccess: userCouponsLoaded.type,
      actionName: 'loadUserCoupons',
      params: { meals }
    })
  );
};



export const loadUserHistory = ({ userId, token }) => async (
  dispatch,
  getState
) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/accounts/${userId}/${token}/?secret_key=${apiToken}`,
      onSuccess: userHistoryLoaded.type,
      actionName: 'loadUserHistory'
    })
  );
};


export const changeCoupon = ({
  mealId,
  date,
  meetingId,
  eventeatingId,
  eatingId,
  couponId,
  token,
  customerId,
  amount
}) => async (dispatch, getState) => {
  const orderDateFormated = date.split('.').join('');

  return await dispatch(
    apiCallBegan({
      url: `/api/ticket/user_eating/?secret_key=${apiToken}`,
      onSuccess: couponChanged.type,
      method: 'patch',
      data: {
        meal_id: mealId,
        date: orderDateFormated,
        meeting_id: meetingId,
        eventeating_id: eventeatingId,
        eating_id: eatingId,
        coupon_id: couponId,
        token,
        customer_id: customerId,
        amount
      },
      params: {
        mealId,
        date,
        meetingId,
        eventeatingId,
        eatingId,
        couponId,
        token,
        customerId,
        amount
      },
      actionName: 'changeCoupon'
    })
  );
};

// export const deleteUserCoupons = (userId, orderDate) => async (
//   dispatch,
//   getState
// ) => {
//   const orderDateFormated = orderDate.split('.').join('');

//   // const checkDateFormated = format(checkDate,'ddMMyyyy')

//   // console.log('loadTeamMeal date', orderDate);
//   return await dispatch(
//     apiCallBegan({
//       url: `/api/ticket/user_delete_eating/${userId}/${orderDateFormated}?secret_key=${apiToken}`,
//       onSuccess: userCouponsDeleted.type,
//       actionName: 'deleteUserCoupons'
//     })
//   );
// };

// Selectors

export const getTeamCouponsSelector = createSelector(
  state => state.entities.team.coupons,
  coupons => coupons
);

export const getTeamPageReadySelector = createSelector(
  state => state.api.requests,
  requests =>
    requests && requests.loadUserCoupons && requests.loadUserCoupons.ready
      ? requests.loadUserCoupons.ready
      : false
);

export const getTeamOrderCouponsSelector = createSelector(
  state => state.entities.team.orderCoupons,
  coupons => coupons
);

export const getTeamTodayCouponsSelector = createSelector(
  state => state.entities.team.todayCoupons,
  coupons => coupons
);

export const getTeamOrderDateSelector = createSelector(
  state => state.entities.team.orderDate,
  orderDate => orderDate
);

export const getTeamTodaySelector = createSelector(
  state => state.entities.team.today,
  today => today
);

export const getTeamOrderForTodaySelector = createSelector(
  state => state.entities.team.orderForToday,
  orderForToday => orderForToday
);

export const getTeamHistorySelector = createSelector(
  state => state.entities.team.history,
  history => history
);
